import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import { SpecialEditionHome } from './SpecialEditionHome'
import { EditionPublication } from '@west-australian-newspapers/message-types'

export interface SpecialEditionHomeRouteProps {
    publicationTitle: string
    lazyloadImages?: boolean
    publication: Omit<EditionPublication, 'the_nightly'> // Omit 'the_nightly' from this component; in future we may want to consolidate The Nightly edition cta's into a singular component
    heading?: string
    showFirstDivider?: boolean
}

export const NightlySpecialEditionHomeRegistration =
    createRegisterableComponentWithData(
        'nightly-special-edition-home',
        EditionLoader,
        (
            {
                publicationTitle,
                lazyloadImages,
                publication,
                heading,
                showFirstDivider,
            }: SpecialEditionHomeRouteProps,
            data,
            services,
        ) => {
            if (!data.loaded) return null
            const edition = data.result.documents?.[0]
            if (!edition) {
                services?.log?.error(data, 'SpecialEditionHome: empty result')
                return null
            }

            return (
                <SpecialEditionHome
                    edition={edition}
                    publicationTitle={publicationTitle}
                    lazyloadImages={lazyloadImages}
                    onEvent={services.onEvent}
                    publication={publication}
                    heading={heading}
                    showFirstDivider={showFirstDivider}
                />
            )
        },
    )
